// External
import join from 'url-join';

// Internal
import { showCartRefreshModal } from '../carts/actions';
import { updateCartEtag } from '../carts/actionCreators';

// Constants
const etagErrorCodes = [412];
const { VITE_API2_URL: api2Url } = import.meta.env;
const paths = {
  api2Beginning: join(api2Url, 'v1', 'carts')
};

// Middleware
export const eTagMiddleware = ({ dispatch }) => next => action => {
  const matches = /(.*)_(SUCCESS|ERROR)/.exec(action.type);
  if (!matches || !action.payload) return next(action);

  const {
    payload: { url: errorUrl = '', status: errorStatus = null, httpMeta: { url = '', ETAG = null } = {} } = {}
  } = action;

  const [requestType, requestName, requestStatus] = matches;

  if (ETAG) {
    dispatch(updateCartEtag({ url, ETAG, requestName, requestType, requestStatus }));
  }

  if (etagErrorCodes.includes(errorStatus) && errorUrl.startsWith(paths.api2Beginning)) {
    dispatch(showCartRefreshModal());
  }

  return next(action);
};

export default eTagMiddleware;
